// TODO - remove becouse of legacy

import React, { useEffect, useState } from 'react'
import { SearchableSelectBase } from 'components'
import { useQuizzesOptions } from '../../hooks/useQuizzesOptions'

type PropsType = {
  campaignId: number
  initialOption: SelectOption
  disabled?: boolean
  allowClear?: boolean
  selected?: string | number
  onSelect: (selectOption: SelectOption) => void
}

const ProductsSelect = (props: PropsType) => {
  const { campaignId, ...rest } = props

  const [searchText, setSearchText] = useState<string>()

  const productOptions = useQuizzesOptions({ campaignId, searchText })

  useEffect(() => {
    productOptions.refetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText])

  return (
    <SearchableSelectBase
      onSearch={setSearchText}
      options={productOptions.data}
      isLoading={productOptions.isLoading || productOptions.isRefetching}
      {...rest}
    />
  )
}

export default ProductsSelect
